module.exports = __webpack_public_path__ + "img/new_tag.c337c651.svg";